import {
  SCROLLABLE_TYPE,
  createBottomSheetScrollableComponent,
  type BottomSheetScrollViewMethods
} from '@gorhom/bottom-sheet';
import type { BottomSheetScrollViewProps } from '@gorhom/bottom-sheet/src/components/bottomSheetScrollable/types';
import { forwardRef, memo } from 'react';
import { ScrollView as GestureScrollView } from 'react-native-gesture-handler';
import type {
  KeyboardAwareScrollViewProps,
  KeyboardAwareScrollViewRef
} from 'react-native-keyboard-controller';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { createAnimatedComponent } from 'react-native-reanimated';

// See: https://kirillzyusko.github.io/react-native-keyboard-controller/docs/api/components/keyboard-aware-scroll-view#gorhombottom-sheet

const LayoutKeyboardAwareScrollView = forwardRef<
  KeyboardAwareScrollViewRef,
  KeyboardAwareScrollViewProps
>(function LayoutKeyboardAwareScrollView(props, ref) {
  return (
    <KeyboardAwareScrollView
      {...props}
      ref={ref}
      mode="layout"
      ScrollViewComponent={GestureScrollView as never}
    />
  );
});
LayoutKeyboardAwareScrollView.displayName = 'LayoutKeyboardAwareScrollView';

const AnimatedScrollView = createAnimatedComponent(
  LayoutKeyboardAwareScrollView
);
const BottomSheetScrollViewComponent = createBottomSheetScrollableComponent<
  BottomSheetScrollViewMethods,
  BottomSheetScrollViewProps
>(SCROLLABLE_TYPE.SCROLLVIEW, AnimatedScrollView);
const BottomSheetKeyboardAwareScrollView = memo(BottomSheetScrollViewComponent);

BottomSheetKeyboardAwareScrollView.displayName =
  'BottomSheetKeyboardAwareScrollView';

export default BottomSheetKeyboardAwareScrollView as (
  props: BottomSheetScrollViewProps & KeyboardAwareScrollViewProps
) => ReturnType<typeof BottomSheetKeyboardAwareScrollView>;
